import PageHeader from 'src/core/ui/PageHeader';
import Footer from 'src/core/ui/helpers/Footer';
import ContentCardsContainer, { CardType, ContentCard } from 'src/core/ui/ContentCard';
import { CustomDataGrid } from 'src/core/tables/CustomDataGrid';
import { generateTablePageButtons } from 'src/core/tables/generateTablePageButtons';
import { useTaxRatesTable } from 'src/pages/settings/admin/taxRates/useTaxRatesTable';

export const TaxRatesTablePage = () => {
    const [columns, tableSettings] = useTaxRatesTable();
    return (
        <>
            <PageHeader {...{
                title: "Tax Rates", subTitle: "View available tax rate codes and values",
                components: generateTablePageButtons(tableSettings),
            }} />
            <ContentCardsContainer>
                <ContentCard cardId="Tax Rates" cardTypes={[CardType.noHeader]} contentPadding={0}>
                    <CustomDataGrid columns={columns} tableSettings={tableSettings} />
                </ContentCard>
            </ContentCardsContainer>
            <Footer />
        </>
    );
};

export default TaxRatesTablePage;
